import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

export default function Loading({open, onClick}) {
  return (
    <>
      <Backdrop
        sx={{ color: "#3399FF", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        onClick={onClick}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
